<template>
    <vs-popup :active.sync="isActive"  title="Gün Sonu" @update:active="handlePopupUpdate">
    <vs-popup class="holamundo"  title="Kaydedilen Fotoğraf" :active.sync="popupActivo">
      <img :src="imageBase64" alt="Fotoğraf" v-if="imageBase64" />
    </vs-popup>
      <vs-popup class="holamundo" :active.sync="isCameraOpen" title="Kamera">
          <div id="app" class="web-camera-container">
  <div class="camera-button">
      <button type="button" class="button1 is-rounded" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">
        <span v-if="!isCameraOpen">Open Camera</span>
    </button>
  </div>

  <div v-show="isCameraOpen && isLoading" class="camera-loading">
    <ul class="loader-circle">
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </div>

  <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">

    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>

    <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>

    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
  </div>

  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <vs-button v-if="isPhotoTaken" @click="savePhoto"  color="transparent" class="bold bg-success text-white ml-2">
              Kaydet
            </vs-button>
            <vs-button v-if="isPhotoTaken" @click="takePhoto"  color="transparent" class="bold bg-danger text-white ml-2">
              İptal
            </vs-button>
    <vs-button v-if="!isPhotoTaken" @click="takePhoto"  color="transparent" class="bold bg-success text-white ml-2">
              Çek
            </vs-button>

  </div>
</div>
        </vs-popup>

        <vs-row vs-type="flex" vs-w="12" class="mt-4">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
              <h3 v-if="isOldClose">{{lastOpenDate}} tarihinde kapatılmamış gün sonu mevcut olduğundan lütfen kasadaki mevcut nakit miktarını sayarak ve Z raporu alarak gün sonunu tamamlayınız.</h3>
<h3 v-else="isOldClose">Lütfen Kasadaki Nakit Parayı Sayarak ve Z Raporu alarak Gün Sonunu Yapınız</h3>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <vs-col  vs-w="5">
            <vs-row vs-type="flex" vs-w="12" class="mt-4">
              <h2 style="text-align: center; margin-left: 3rem;">NAKİT</h2>
           <vs-input @focus="$event.target.select()" id="Nakit" name="Nakit" v-validate="'required'" v-model="safeCash" label="Kasadaki Nakit Tutarı: " @input="handleInput">

            </vs-input>
            <vs-input @focus="$event.target.select()" id="NextDayCash" name="NextDayCash" v-validate="'required'" v-model="nextDayCash" label="Ertesi Güne Devir Tutar: " @input="handleInput">

              </vs-input>
              <h2 style="text-align: center; margin-left: 1rem; margin-top: 1rem; margin-bottom: 1rem;">KREDİ KARTI</h2>
           <vs-input @focus="$event.target.select()" id="XReport" name="XReport" v-validate="'required'" v-model="xCash" label="Z Raporu Tutarı: " @input="handleInput">

            </vs-input>

        </vs-row>
        <vs-row>
          <feather-icon
                icon="CameraIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  toggleCamera
                "
              />
              <feather-icon v-if="imageBase64"
                icon="ImageIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  popupActivo=true
                "
              />
        </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3">
            <vs-row vs-type="flex" vs-w="12" class="mt-4">
              <vs-col vs-type="flex" vs-w="12" vs-justify="center">
               <h2 style="text-align: center; margin-left: 6rem;">DİĞER</h2>

          </vs-col>
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" id="Multinet" name="Multinet" v-validate="'required'" v-model="multinet" label="Multinet: " @input="handleInput">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" id="Sodexo" name="Sodexo" v-validate="'required'" v-model="sodexo" label="Sodexo/Pluxee: " @input="handleInput">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" @input="handleInput" id="Ticket" name="Ticket" v-validate="'required'" v-model="ticket" label="Ticket: ">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" @input="handleInput" id="Setcard" name="Setcard" v-validate="'required'" v-model="setCard" label="Setcard: ">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" @input="handleInput" id="Migros" name="Migros" v-validate="'required'" v-model="migros" label="Migros: " >

            </vs-input>

          </vs-col>
        </vs-row>
          </vs-col>
          <vs-col class="ml-1" vs-type="flex" vs-w="3">
            <vs-row vs-type="flex" vs-w="12" class="mt-4">
              <vs-col vs-type="flex" vs-w="12" vs-justify="center">
               <h2 style="text-align: center; margin-left: 3rem;"></h2>

          </vs-col>
            <vs-col style="margin-top: 1.8rem;" vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" @input="handleInput" id="Metropol" name="Metropol" v-validate="'required'" v-model="metropol" label="Metropol: ">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" id="Tokenflex" name="Tokenflex" v-validate="'required'" v-model="tokenflex" label="Tokenflex: " @input="handleInput">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" @input="handleInput" id="Getir" name="Getir" v-validate="'required'" v-model="getir" label="Getir: " >

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" id="YemekSepeti" name="YemekSepeti" v-validate="'required'" v-model="yemekSepeti" label="YemekSepeti: " @input="handleInput">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" @input="handleInput" id="IWallet" name="IWallet" v-validate="'required'" v-model="iWallet" label="iWallet: " >

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" id="Paye" name="Paye" v-validate="'required'" v-model="paye" label="Paye: " @input="handleInput">

            </vs-input>

          </vs-col>
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" @input="handleInput" id="Trendyol" name="Trendyol" v-validate="'required'" v-model="trendyol" label="Trendyol: ">

            </vs-input>

          </vs-col>
        </vs-row>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">

          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
            <vs-button @click="showPopup" size="large" color="transparent" class="bold bg-success text-white ml-2">
              Onayla
            </vs-button>
          </vs-col>
        </vs-row>
      <div fullscreen style="z-index: 9999999;" class="popup-overlay" v-if="showPopupFlag">
        <div fullscreen class="popup">
          <h3>Gün Sonu Raporu’nu kaydetemek istediğinize emin misiniz?</h3>
          <button class="btn btn-primary" @click="forcelose">Kaydet</button>
          <button class="btn btn-secondary" @click="closePopup">İptal</button>
        </div>
      </div>
    </vs-popup>
  </template>

  <script>
  import {
    createDayOpen,
    createDayInterim,
    createDayClose,
    uploadImage
  } from "@/api/DayOpen.js";
  import companyInfo from "../../../model/constants/companyInfo";
import { parse } from "path";
  export default {
    data() {
      return {
        isActive: false, // Pop-up'ı başlangıçta açık tutmak için
        logo: companyInfo.logo,
        showPopupFlag: false,
        safeCash: 0,
        xCash: 0,
        multinet: 0,
        sodexo:0,
        ticket:0,
        setCard:0,
        migros: 0,
        metropol: 0,
        tokenflex: 0,
        getir: 0,
        yemekSepeti: 0,
        iWallet: 0,
        paye: 0,
        trendyol: 0,
        isOldClose : false,
        nextDayCash:0,
        lastOpenDate :'',
        isCameraOpen: false,
        isPhotoTaken: false,
        isShotPhoto: false,
        isLoading: false,
        link: '#',
        imageBase64: null,
        popupActivo:false,
        imageData: null,
        imageUrl: null,
        binaryString: null
      };
    },
    watch:{
      safeCash(newSafeCash){
        if (parseFloat(this.nextDayCash) > parseFloat(newSafeCash)) {
        this.nextDayCash = newSafeCash;
      }
      },
      nextDayCash(newNext){
        console.log('test');

        if (parseFloat(newNext) > parseFloat(this.safeCash)) {
          console.log('büyük');
        this.nextDayCash = this.safeCash;
      }
    }
    },
    computed:{
      activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    }
    },
    methods: {
      savePhoto(){
        this.imageData = this.convertBinaryStringToUint8Array(this.binaryString);
      // Binary string'i base64 dizgesine geri dönüştür
      const base64Data = this.convertBinaryStringToBase64(this.binaryString);

      // Base64 dizgesini görüntüle
      this.imageBase64 = base64Data
        this.toggleCamera();
        this.$vs.notify({
            color: 'success',
            title: 'Görüntü Kaydedildi',
            text: 'Görüntü Kaydedildi !'
          });
      },
      toggleCamera() {
        this.isPhotoTaken = false;
      if(this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
				audio: false,
				video: true
			});


			navigator.mediaDevices
				.getUserMedia(constraints)
				.then(stream => {
          this.isLoading = false;
					this.$refs.camera.srcObject = stream;
				})
				.catch(error => {
          this.isLoading = false;
					alert("May the browser didn't support or there is some errors.");
				});
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

			tracks.forEach(track => {
				track.stop();
			});
    },
    takePhoto() {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
       // Canvas görüntüsünü base64 kodlu dizgeye dönüştür
  const base64Image = this.$refs.canvas.toDataURL('image/jpeg');

// Base64 dizgesini binary veriye dönüştür
   this.binaryString = this.convertBase64ToBinaryString(base64Image);

    },
    convertBase64ToBinaryString(base64String) {
      return window.atob(base64String.split(',')[1]);
    },
    convertBinaryStringToUint8Array(binaryString) {
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
},
    convertBinaryStringToBase64(binaryString) {
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const base64 = window.btoa(String.fromCharCode(...bytes));
      return `data:image/jpeg;base64,${base64}`;
    },
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
    .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },
      handlePasteForSingleInput(event) {
      // Yapıştırma işlemi sırasında içerikte harf varsa iptal et
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');

      if (/\D/.test(pastedText)) {
        // Harf içeriyorsa yapıştırmayı iptal et
        event.preventDefault();
      } else {
        // Sadece sayıları kabul et
        this.myInputValue = pastedText.replace(/[^0-9]/g, '');
      }
    },

      onlyNumber ($event) {
   //console.log($event.keyCode); //keyCodes value
   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
   if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
      $event.preventDefault();
   }},
        handleInput() {
      // Girilen değeri kontrol et
      if (this.safeCash !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.safeCash)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.safeCash = this.safeCash.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.xCash)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.xCash = this.xCash.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.multinet)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.multinet = this.multinet.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.sodexo)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.sodexo = this.sodexo.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }if (!regex.test(this.ticket)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.ticket = this.ticket.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.setCard)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.setCard = this.setCard.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.migros)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.migros = this.migros.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.metropol)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.metropol = this.metropol.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.tokenflex)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.tokenflex = this.tokenflex.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.getir)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.getir = this.getir.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.yemekSepeti)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.yemekSepeti = this.yemekSepeti.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.iWallet)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.iWallet = this.iWallet.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.paye)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.paye = this.paye.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.trendyol)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.trendyol = this.trendyol.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.nextDayCash)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.nextDayCash = this.nextDayCash.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
        if (!regex.test(this.xCash)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.xCash = this.xCash.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
      }
    },
        showPopup: async function () {
          let checker = await this.$validator.validateAll();
         if (!checker) {
          return;
         }
        this.showPopupFlag = true
      },
        closePopup() {
        this.showPopupFlag = false;
      },
        forcelose: async function () {
          if (this.imageData) {
            let formData = new FormData();
          formData.append('image', new Blob([this.imageData], { type: 'image/jpeg' }), 'image.jpg');
          this.imageUrl ='StaticFiles/images/' + (await uploadImage(formData)).data;
          console.log(this.imageUrl);
          }
            createDayClose({safeCash :this.safeCash, xReportForCard : this.xCash,multinetReport: this.multinet,
              sodexoReport: this.sodexo, ticketReport: this.ticket, setcardReport:this.setCard, metropolReport: this.metropol,
              tokenflexReport:this.tokenflex, getirReport: this.getir, yemekSepetiReport: this.yemekSepeti,
              iWalletReport: this.iWallet, payeReport: this.paye, trendyolReport: this.trendyol, migrosReport: this.migros,nextDayCash: this.nextDayCash,userId:this.activePersonel.id,
            userName: this.activePersonel.name,imageUrl: this.imageUrl }).then(res =>{
                if (res && res.status == 200) {
                    this.$vs.notify({
            color: 'success',
            title: 'Gün sonu başarılı',
            text: 'Gün sonu başarılı !'
          });
          this.$emit("emitCloseReport", true);
          location.reload();
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ödeme Raporu Yüklenemedi !'
            });
          }
            }).catch(error => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: error.response.data.Errors[0].Message
          });
        })
            // this.isActive = false;
             this.showPopupFlag = false;
        },
      preventCloseOnClick() {
        // İhtiyaca göre özel mantık ekleyebilirsiniz
      },
      handlePopupUpdate(newValue) {
      // Pop-up durumu güncellendiğinde tetiklenir
      if (!newValue && this.isOldClose) {
        // Pop-up kapatıldığında yapılacak işlemler
        this.isActive = true; // Pop-up'ı tekrar açmak için
      }
    },
    },
  };
  </script>
  <style>

  .logo{
    background-color: white;
       border-radius: 10px;
    margin-bottom: 1rem;
  }
  #switchScreen{
    z-index: 999999;
  }
  #switchScreen .vs-popup .vs-popup--header {
    display: none !important;
  }

  #switchScreen .vs-popup .vs-popup--content {
    padding: 0 !important;
    /*height: 47vh;*/
  }

  #switchScreen .vs-popup {
    background: transparent !important;
    box-shadow: none !important;
  }

  #switchScreen input {
    font-size: 2rem !important;
    background: #f2f2f2 0% 0% no-repeat padding-box !important;
    text-align: center !important;
    padding: 0.5rem;
  }

.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 500px;


  .camera-button {
    margin-bottom: 2rem;
  }

  .camera-box {
    .camera-shutter {
      opacity: 0;
      width: 450px;
      height: 337.5px;
      background-color: #fff;
      position: absolute;

      &.flash {
        opacity: 1;
      }
    }
  }

  .camera-shoot {
    margin: 1rem 0;

    button1 {
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;

      img {
        height: 35px;
        object-fit: cover;
      }
    }
  }

  .camera-loading {
    overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    min-height: 150px;
    margin: 3rem 0 0 -1.2rem;

    ul {
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 999999;
      margin: 0;
    }

    .loader-circle {
      display: block;
      height: 14px;
      margin: 0 auto;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      transform: translateX(-50%);
      position: absolute;
      width: 100%;
      padding: 0;

      li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        top: -50%;
        border-radius: 100%;

        &:nth-child(2) {
          animation-delay: .2s;
        }

        &:nth-child(3) {
          animation-delay: .4s;
        }
      }
    }
  }

  @keyframes preload {
    0% {
      opacity: 1
    }
    50% {
      opacity: .4
    }
    100% {
      opacity: 1
    }
  }
}
  </style>
